export default __webpack_public_path__ + "static/media/payment-active.a513bc95.svg";